import { AptiveIcon } from '@aptive-env/storybook'
import { IEmployee } from 'interface/employee'
import { FC, useState } from 'react'
import { RenderParticipant } from 'components/EventUpdateModal/EventModalComponents'

interface ParticipantExpandableListProps {
  participants: IEmployee[]
}

const ParticipantExpandableList: FC<ParticipantExpandableListProps> = ({
  participants,
}) => {
  const [isParticipantsExpanded, setIsParticipantsExpanded] = useState(false)

  return (
    <div className="overflow-hidden">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setIsParticipantsExpanded(!isParticipantsExpanded)}
      >
        <div className="text-xs text-medium-gray-100">
          {participants.length} guest{participants.length > 1 ? 's' : ''}
        </div>
        <AptiveIcon
          icon="chevronDown"
          className="w-[16px] h-[16px] stroke-medium-gray-100 fill-none"
        />
      </div>
      {isParticipantsExpanded ? (
        <div className="ml-2 mt-3">
          {participants.map((participant) => (
            <div className="flex items-center gap-2 mt-2" key={participant.id}>
              <div className="h-[32px] w-[32px] flex-none rounded-full overflow-hidden bg-ui-gray-200">
                <RenderParticipant participant={participant} />
              </div>
              <div className="text-xs text-dark-gray-100">
                {participant.name}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          <div className="text-xs text-medium-gray-100 mt-3 mb-3">
            <span>
              {participants
                .slice(0, Math.min(4, participants.length))
                .map((participant) => participant.name)
                .join(', ')}
            </span>
            {participants.length > 4 && (
              <span>
                &nbsp;and {participants.length - 4} other
                {participants.length - 4 > 1 ? 's' : ''}
              </span>
            )}
          </div>
          <div className="flex gap-[1px] overflow-auto">
            {participants.map((participant) => (
              <div
                className="h-[32px] w-[32px] flex-none rounded-full overflow-hidden bg-ui-gray-200"
                key={participant.id}
              >
                <RenderParticipant participant={participant} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ParticipantExpandableList
